import React from 'react';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';

import { formStyles } from 'consts/styles/Form';
import ButtonsUseStyles from 'consts/styles/Buttons';

const FinishedInfo = props => {
  const { handleClose, language } = props;

  const formClasses = formStyles();
  const classesButtons = ButtonsUseStyles();

  const [closeTime, setCloseTime] = React.useState(10);

  React.useEffect(() => {
    const myInterval = setInterval(() => {
      if (closeTime > 0) {
        setCloseTime(prev => prev - 1);
      }
      if (closeTime === 0) {
        clearInterval(myInterval);
        handleCloseModal();
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  const handleCloseModal = () => handleClose();

  return (
    <Grid
      container
      className={`${formClasses.Form}__text-field ${formClasses.Form}__text-field__title`}
    >
      <Grid item xs={12}>
        {language.zonesDetails.addForm.finishedInfo.in_}{' '}
        {closeTime < 10 ? <>0{closeTime}&nbsp;</> : <>{closeTime}&nbsp;</>}
        {language.zonesDetails.addForm.finishedInfo.secondPart_}{' '}
        <Button
          onClick={() => handleCloseModal()}
          className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle} `}
        >
          {language.zonesDetails.addForm.finishedInfo.button_}
        </Button>{' '}
        {language.zonesDetails.addForm.finishedInfo.lastPart_}
      </Grid>
    </Grid>
  );
};

FinishedInfo.propTypes = {
  handleClose: PropTypes.func.isRequired,
  language: PropTypes.object.isRequired,
};

export default FinishedInfo;
